<script>
  import { db, firebaseFunctions } from "../etc/firebase.js"
  import GuaSummary from "./GuaSummary.svelte"
  import { userStore, guaRecordStore, userGuaCount } from "../etc/store.js"
  import AesCtr from "../etc/aes-ctr.js"
  import {
    backToTop,
    scrollToId,
    stickReduction,
    categories,
    btn_style_yellow_d2,
    xiyiSalt,
  } from "../etc/helpers.js"

  let sectionName = "AutoQi"
  // Listen for auth status change
  let isLogin = false
  let createdDT = ""
  let userName = ""
  let firebaseUid = ""
  // console.log(categories)
  let guaCount = 0
  let mergedSeed = ""
  let numStr = ""
  let guaNumbers = ""
  let qiGuaDT = ""
  let recorder = ""
  let qiGuaPerson = ""
  $: qiGuaPerson = userName
  let guaType = "auto"
  let question = ""
  let question_copy = ""
  let category = ""
  let tag = []
  let new_tag = ""
  let tagString = ""
  let tagAdded = false
  let explanation = ""
  let ranking = ""
  let comment = ""
  let recordDT = ""
  let guaSubmitted = false
  // Listen for auth status change

  // console.log("@ AutoQi: Got salt: ", xiyiSalt)

  $: if ($userStore.isLogin == true) {
    isLogin = true
    firebaseUid = $userStore.userInfo.firebaseUid
    userName = $userStore.userInfo.userName
    recorder = userName
    // console.log("@ AutoQi: getting firebaseUid : ", firebaseUid)
    // console.log("@ AutoQi: getting userName : ", userName)
  } else {
    isLogin = false
  }

  let requiredFieldReady = false
  $: question != "" && category != "" && qiGuaPerson != ""
    ? (requiredFieldReady = true)
    : (requiredFieldReady = false)

  /*********
   * The genGua algorithm is as the following:
   * 1, Create input string to hash using Sha256
   *    Date + QiGua User Name + Question + Yao# (1, 2, 3, 4, 5, 6) + Split# (1, 2, 3)
   * 2, Get the Hash Code, converting it to Integer
   * 3, Divide the hash_quotien = hash_in / timestamp_int
   * 4, Mode hash_quotien by base_range according to split# and remaining stick count
   *    (base_range: 29, 25, 23, 21, 19, 17)
   * 5, kick_index = hash_quotien + start_index (according to split# and remaining stick count)
   * 6, wait hash_quotien ms and get the next kick_index for total 6 yao * 3 splits = 18 times
   * 7, is the return value of genKick and the index to kick out.
   * *********/
  function genGua() {
    // numStr will be a 6-char long string consists of [6|7|8|9] and send it to GuaResult
    numStr = "" // initialize to empty string before building gua

    // mergedSeed will be differ by yao_count and split_count
    mergedSeed = userName + question

    // Timestamp will be captured in the stickReduction function for *** EACH Yao ***
    numStr = stickReduction(mergedSeed)

    // Record Gua in Firebase
    recordGua(numStr)

    // Cloud QiGua quality no good. Forget about it.
    // const cloudGenGua = firebaseFunctions.httpsCallable("genGua")
    // cloudGenGua().then((result) => {
    //   console.log("Got cloudGenGua return value = ", result)
    // })
  }

  function recordGua(numStr) {
    //console.log("@ AutoQi: In recordGua numStr = " + numStr)
    guaNumbers = numStr
    //comment = explanation
    guaCount = $userStore.guaCount

    recordDT = Date.now()
    qiGuaDT = recordDT

    const encryptedQuestion = AesCtr.encrypt(question, xiyiSalt, 256)
    const decryptedQuestion = AesCtr.decrypt(encryptedQuestion, xiyiSalt, 256)

    // console.log(
    //   "@ AutoQi.recordGua: question and encryptedQuestion = " +
    //     question +
    //     ", " +
    //     encryptedQuestion
    // )
    // console.log("@ AutoQi.recordGua: decryptedQuestion = ", decryptedQuestion)

    // alert(
    //   "Check encryption: " +
    //     question +
    //     ", " +
    //     encryptedQuestion +
    //     ", " +
    //     decryptedQuestion
    // )

    db.collection("guaRecords")
      .add({
        firebaseUid,
        qiGuaDT,
        recordDT,
        guaType,
        qiGuaPerson,
        recorder,
        // question,
        encryptionOn: true,
        question: encryptedQuestion,
        category,
        tag,
        guaNumbers,
      })
      .then(() => {
        // $userStore.guaCount = $userStore.guaCount + 1
        // console.log(
        //   "@ AutoQi: Added a new Qua! $userStore.guaCount = " + $userStore.guaCount
        // )
        updateGuaRecordStore(firebaseUid)
        // location.assign("/records")
      })

    guaSubmitted = true
    question_copy = question

    qiGuaDT = ""
    guaNumbers = ""
    explanation = ""
    question = ""
    category = ""
    tag = []
    new_tag = ""
    ranking = ""
    comment = ""
    tagAdded = false
    //alert(`submitted ${numStr}`);
    //alert("@ AutoQi: Hold it!")

    backToTop()
  }

  // Update guaRecordStore (localStorage)
  function updateGuaRecordStore(firebaseUid) {
    // console.log("@ AutoQi: Updatng GuaRecordStore for UID: " + firebaseUid)

    let guaRecords = []
    let guaCount = 0
    db.collection("guaRecords")
      .where("firebaseUid", "==", firebaseUid)
      .get()
      .then((querySnapshot) => {
        guaCount = 0
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          guaCount++
          let tmpArray = doc.data()
          tmpArray.show = true
          tmpArray.id = doc.id
          guaRecords.push(tmpArray)
        })
        // sort the guaRecords per recordDT as default sort.
        //  console.log("@ Record: before sort guaRecords = ", guaRecords)
        guaRecords.sort((a, b) => (a.recordDT < b.recordDT ? 1 : -1))
        //  console.log("@ Record: after sort guaRecords = ", guaRecords)

        // currentUserGuaCount.set(guaCount)
        // $userStore.guaCount = guaCount
        // $userStore.guaRecords = [...guaRecords]
        $guaRecordStore = JSON.stringify(guaRecords)
        $userGuaCount = guaCount
        // console.log(
        //   "@ AutoQi: guaCount in $userGuaCount is updated = " + $userGuaCount
        // )
        // console.log(
        //   "@ Record: $userStore.guaRecords = ",
        //   $userStore.guaRecords
        // )
        // console.log(
        //   "@ AutoQi: +++ the refreshed JSON.parse($guaRecordStore) = ",
        //   JSON.parse($guaRecordStore)
        // )
        //location.assign("/records")
      })
      .catch(function (error) {
        console.log("@ AutoQi: Error getting guaRecords documents: ", error)
      })
  }

  function addTag() {
    tag.push(new_tag.toUpperCase())
    tagString = tag.toString()
    tagAdded = true

    // console.log("@ AutoQi: a new tag added: " + new_tag)
    // console.log("@ AutoQi: tag is now: " + tag.toString())
    // console.log("@ AutoQi: tag length is: " + tag.length)

    new_tag = ""

    scrollToId("autoqi-form")
  }
</script>

<div class="gua-result" id="show-autoqi">
  {#if !guaSubmitted}
    <div>
      <h3>自動起卦</h3>
      <h5 style="color:red">*** 僅供習易參考、千萬不可迷信 ***</h5>
      <p>起卦的要件，第一就是心要誠，第二就是意要定。</p>
      <p>
        自己親手起卦，無論是操作大衍法還是金錢卦，總是需要一段時間的心誠、意定、以及安靜的環境。一般人，心也許夠誠，
        但是意總是難定，安靜的時機和環境更是難得。使用這個自動起卦功能，您可以先把問題想好，
        然後，只要能在很短的時間之內保持心誠意定，按下自動起卦鍵，結果立刻上傳到您的卦例檔案裡。
      </p>
    </div>
    <div class="qi-option">
      <div class="gua-form">
        <form class="content" id="autoqi-form">
          <label>* 起卦人：</label>
          <input type="text" bind:value={qiGuaPerson} required />

          <br />
          <div class="category">
            <label>* 問事類別： </label>
            {#each categories as item}
              <label class="cat-item">
                <input
                  type="radio"
                  bind:group={category}
                  value={item}
                  on:click={() => scrollToId("autoqi-form")}
                />
                <span class="checkbox-spacing">{item}</span>
              </label>
            {/each}
            <br /><br /><span class="blue-text darken-2"
              ><strong>
                {category == "" ? "" : "選定類別: " + category}</strong
              ></span
            >
          </div>
          <br />
          <div class="tag-field">
            <label>您也可以加入額外標記(tags)，以便自己將來搜尋卦例：</label>
            <input type="text" bind:value={new_tag} />
            <button on:click|preventDefault={addTag} class={btn_style_yellow_d2}
              >加入標記</button
            >
            <br /><br /><span class="blue-text darken-2"
              ><strong>
                {tagAdded ? "已加入的額外標記： " + tagString : ""}
              </strong></span
            >
            <br />
          </div>
          <br />

          <div class="input-field">
            <label>* 問題：</label>
            <input type="text" bind:value={question} required />
          </div>
          <div class="before-qi">
            <h5>心靜意誠</h5>
            <p>
              在按下【自動起卦】鍵前，心要靜、意要誠。有需要的話，您可以在心中默念如下禱辭，以幫助您靜下心來：
            </p>
            <p>仿【朱熹 周易本義】筮儀禱辭：</p>
            <div class="qi-talk">
              <p>
                <!-- <img src="images/arrow_forward-24px.svg" alt="arrow-forward" /> -->
                假爾泰筮有常，假爾泰筮有常，某{qiGuaPerson}，今問{question}，未知可否？爰質疑于神于靈，吉凶得失，悔吝憂虞，惟爾有神，尚明告之。
              </p>
            </div>

            <p>或是用較現代的說法：</p>
            <div class="qi-talk">
              <p>
                <!-- <img src="images/arrow_forward-24px.svg" alt="arrow-forward" /> -->
                我是{qiGuaPerson}，藉著大易筮占的靈驗，今天想請問{question}，有關這個問題的吉凶得失，悔吝憂虞？還請麻煩告訴我，謝謝。
              </p>
            </div>
            <p>如果您的心能靜、意也誠，那麼什麼都不說、不唸也無所謂。</p>
          </div>
          <button
            disabled={!requiredFieldReady}
            class="auto-qi-button btn waves-effect waves-light blue darken-2 "
            on:click={genGua}
          >
            自動起卦
          </button>
        </form>
      </div>
    </div>
    <br />
  {:else}
    <hr />
    <div class="gua-result" id="show-summary">
      <GuaSummary {numStr} question={question_copy} {sectionName} {isLogin} />
      <hr />
    </div>
  {/if}
</div>

<style>
  .auto-qi-button {
    width: 100%;
    height: 100px;
    vertical-align: middle;
    text-align: center;
    line-height: 100px;
    font-size: xx-large;
  }
  .gua-form {
    background-color: #eeeeff;
  }
  .checkbox-spacing {
    padding-left: 25px;
    padding-right: 25px;
  }
  .cat-item {
    border-left: 2px solid;
    padding-left: 10px;
  }
  .qi-talk {
    /* vertical-align: middle; */
    /* margin: auto; */
    /* height: 50px; */
    margin-left: 15px;
    margin-right: 15px;
    padding: 10px 20px 10px 20px;
    background-color: #c5cae9;
    font-size: 20px;
    font-weight: 300;
    color: #283593;
  }
</style>
